"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcRegisterEntryPartnerSelector = class UcRegisterEntryPartnerSelector extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    onOptionSelected(...args) {
        const [{ option, value }] = args;
        if (_.isString(option)) {
            this.editor.partner = { name: option };
        }
    }
    editor;
    onEditor(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("editor");
    }
    messages;
    ux;
    b_2248226175642056_dataSource;
    async $$load_b_2248226175642056_dataSource() {
        return {
            name: "suggest_company",
            parameters: {
                exclude: [this.editor.version.company_id],
            },
        };
    }
    b_2248226175642056_optionTemplate;
    dataMembers = ['messages', 'ux', 'b_2248226175642056_dataSource', 'b_2248226175642056_optionTemplate'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                messages: {
                    searchPlaceholder: this.$fn.pgettext("Register", "Search for partner"),
                },
                ux: null,
                b_2248226175642056_dataSource: null,
                b_2248226175642056_optionTemplate: "<div>\n\
  <span v-if=\"!option.id\">{{ option.name }}</span>\n\
  <UcSuggestCompanyOption2 v-if=\"option.id\" :option=option></UcSuggestCompanyOption2>\n\
</div>",
            },
        };
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_script_8068_getActionArgs_value($event) {
        this.onOptionSelected($event.data);
    }
    async act_2248226175642056_script_8068_getActionArgs($event) {
        return {
            value: () => this.act_2248226175642056_script_8068_getActionArgs_value($event),
        };
    }
    async evh_2248226175642056_optionSelected(event, scope) {
        return await this.actions.evh_2248226175642056_optionSelected.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_8066 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_8065 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_8066,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_8065],
        });
        const act_2248226175642056_script_8068 = new core_1.actions.ScriptAction({
            actionArgs: this.act_2248226175642056_script_8068_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_optionSelected_8067 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_script_8068,
            event: "optionSelected",
            displayName: "script",
        });
        const evh_2248226175642056_optionSelected = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_optionSelected_8067],
        });
        return {
            act_7315092382398562_reloadComponentData_8066,
            evh_7315092382398562_reload_8065,
            evh_7315092382398562_reload,
            act_2248226175642056_script_8068,
            evh_2248226175642056_optionSelected_8067,
            evh_2248226175642056_optionSelected,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcRegisterEntryPartnerSelector.prototype, "editor", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('editor'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcRegisterEntryPartnerSelector.prototype, "onEditor", null);
UcRegisterEntryPartnerSelector = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcRegisterEntryPartnerSelector);
exports.default = UcRegisterEntryPartnerSelector;
vue_property_decorator_1.Vue.component("UcRegisterEntryPartnerSelector", UcRegisterEntryPartnerSelector);
